import React, { useState } from "react";
import { Container, Accordion, Table, Button } from "react-bootstrap";

const priceListData = [
  {
    category: "Waxing",
    packages: [
      { name: "Full Body Wax", price: 1629, offerPrice: 1299 },
      { name: "Upper Body Wax", price: 999 },
      { name: "Lower Body Wax", price: 899 },
    ],
  },
  {
    category: "Facials",
    packages: [
      { name: "Banana Hydrating Facial", price: 899, offerPrice: 699 },
      { name: "Vitamin C Brightening Facial", price: 999 },
    ],
  },
  {
    category: "Threading",
    packages: [
      { name: "Eyebrow Threading", price: 299 },
      { name: "Upper Lip Threading", price: 199 },
    ],
  },
];

export default function PriceListPage() {
  // Track which keys are currently open
  const [openKeys, setOpenKeys] = useState([]);

  const toggleKey = (key) => {
    setOpenKeys((prevKeys) =>
      prevKeys.includes(key)
        ? prevKeys.filter((k) => k !== key) // close if already open
        : [...prevKeys, key] // open if closed
    );
  };

  return (
    <Container className="py-4">
      <h1 className="mb-4 text-center" style={{fontSize:25}}>Our Price List</h1>
      <Accordion  defaultActiveKey={['0','1','2']} alwaysOpen>
        {priceListData.map((category, index) => (
          <Accordion.Item eventKey={index.toString()} key={index}>
            <Accordion.Header onClick={() => toggleKey(index.toString())}>
              {category.category}
            </Accordion.Header>
            <Accordion.Body>
              <div className="table-responsive">
                <Table striped bordered hover className="align-middle mb-0" style={{fontSize:14}}>
                  <thead className="table-light">
                    <tr>
                      <th>Service / Package</th>
                      <th>Original Price</th>
                      <th>Offer Price</th>
                     
                    </tr>
                  </thead>
                  <tbody>
                    {category.packages.map((pkg, idx) => (
                      <tr key={idx}>
                        <td>{pkg.name}</td>
                        <td>
                          {pkg.offerPrice ? (
                            <span style={{ textDecoration: "line-through", color: "#888" }}>
                              ₹{pkg.price}
                            </span>
                          ) : (
                            `₹${pkg.price}`
                          )}
                        </td>
                        <td>
                          {pkg.offerPrice ? (
                            <span style={{ color: "#2062AF", fontWeight: 600 }}>
                              ₹{pkg.offerPrice}
                            </span>
                          ) : (
                            "-"
                          )}
                        </td>
                        
                      </tr>
                    ))}
                  </tbody>
                </Table>
              </div>
            </Accordion.Body>
          </Accordion.Item>
        ))}
      </Accordion>
    </Container>
  );
}


